import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AutenticacaoModule, AuthContext } from "../../../Contexto/auth";
import useLocalStorageSec from "../../../hook/useLocalStorageSec";
import { ILogin, LoginSchema } from "../../../interfaces/ILogin";
import { UsuarioEnviarConfirmacaoEmail } from "../../../services/Identity.Service";
import { showToast } from "src/componentes";
import jwtDecode from "jwt-decode";
import { isPendenteCadastroUsuario } from "src/pages/Privada/CadastroInicial/CadastroInicial.Dto";

export const LoginCode = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setItem, getItem } = useLocalStorageSec();
  const { isLogged, empresaId, userId } = AutenticacaoModule();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ILogin>({
    resolver: yupResolver(LoginSchema),
  });

  useEffect(() => {
    const Load = () => {
      if (isLogged) {
        if (empresaId === 0) {
          navigate("/cadastro-inicial/empresa");
        } else if (isPendenteCadastroUsuario(userId)) {
          navigate("/minhaconta");
        } else {
          navigate("/inicio");
        }
      }
    };
    Load();
  }, [isLogged, empresaId, userId, navigate]);

  useEffect(() => {
    if (getItem("login")) {
      setValue("email", getItem("login").email);
      setValue("senha", getItem("login").senha);
      setValue("lembrar", getItem("login").lembrar);
    }
  }, []);

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const onSubmit = async (loginData: ILogin, event: any) => {
    event.preventDefault();
    setLoading(true);

    await authContext
      .logIn(loginData)
      .then((response) => {
        if (response.success) {
          if (loginData.lembrar) {
            setItem("login", loginData);
          }

          let empresaIdFromToken = 0;
          let userIdFromToken: number | string | undefined = undefined;
          try {
            if (response.data?.token_access) {
              const decoded = jwtDecode<{
                empresaid?: number | string;
                nameid?: number | string;
              }>(response.data.token_access);
              if (
                decoded?.empresaid !== undefined &&
                decoded?.empresaid !== null
              ) {
                empresaIdFromToken = Number(decoded.empresaid);
              }
              if (decoded?.nameid !== undefined && decoded?.nameid !== null) {
                userIdFromToken = decoded.nameid;
              }
            }
          } catch (e) {
            console.error("Erro ao decodificar token no login:", e);
          }

          if (empresaIdFromToken === 0) {
            navigate("/cadastro-inicial/empresa");
            return;
          }

          if (isPendenteCadastroUsuario(userIdFromToken)) {
            navigate("/minhaconta");
            return;
          }

          const redirectUrl = localStorage.getItem("redirectAfterLogin");
          localStorage.removeItem("redirectAfterLogin");
          if (
            redirectUrl &&
            redirectUrl !== "" &&
            redirectUrl !== "/login" &&
            redirectUrl !== "/"
          ) {
            window.location.href = redirectUrl;
          } else {
            navigate("/inicio");
          }
        } else {
          LoginError(response, loginData);
        }
      })
      .catch((error) => {
        console.error("Erro durante o login:", error);
        showToast({
          message: "Ocorreu um erro durante o login.",
          title: "Erro",
          variant: "Warning",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const LoginError = (response: any, loginData: ILogin) => {
    if (
      response.notifications[0]?.message === "EMAIL_PENDENTE_CONFIRMACAO" ||
      response.notifications[0]?.message === "Usuário não liberado"
    ) {
      UsuarioEnviarConfirmacaoEmail(loginData)
        .then((emailRes) => {
          if (emailRes.success) {
            showToast({
              message: "E-mail de confirmação enviado, verifique seu e-mail!",
              variant: "Info",
            });
          } else {
            showToast({
              message: emailRes.notifications[0].message,
              title: "Aviso",
              variant: "Warning",
            });
          }
          navigate("/confirmar-email", { state: { email: loginData.email } });
        })
        .catch((error) => {
          console.error("Erro ao enviar e-mail de ativação:", error);
          showToast({
            message:
              "Não foi possível enviar o e-mail de ativação automaticamente. Prossiga para a confirmação ou tente reenviar.",
            title: "Aviso",
            variant: "Warning",
          });
          navigate("/confirmar-email", { state: { email: loginData.email } });
        });
    } else {
      showToast({
        message: response.notifications[0].message,
        title: "Erro",
        variant: "Warning",
      });
    }
  };

  return {
    onSubmit,
    loading,
    onClickNavigate,
    handleSubmit,
    register,
    errors,
  };
};
